import { createTheme, darken } from '@material-ui/core/styles';
import deepmerge from '../mui-deepmerge';
import { BOWTIE_BLUE, BOWTIE_PINK, GRAPHITE, GREEN_DAY, HOTEL_CALIFORNIA, INK, PEBBLE, ROCK, STONE, WHITE, YELLOW_SUBMARINE } from '../palette';
import { cjkTypographyVariant, typographyVariant } from '../Typography';
import shadows from './shadows';
const FONTS = ['Gilroy', 'Noto Sans CJK TC', 'Noto Sans TC', 'Helvetica', 'Arial', 'sans-serif'];
const typographyOptions = deepmerge(typographyVariant, {
  fontFamily: FONTS.join(','),
  fontSize: 16,
  button: {
    textTransform: 'unset'
  }
});
const defaultTheme = {
  palette: {
    common: {
      black: INK,
      white: WHITE
    },
    type: 'light',
    primary: {
      main: BOWTIE_PINK,
      dark: darken(BOWTIE_PINK, 0.2)
    },
    secondary: {
      main: BOWTIE_BLUE
    },
    text: {
      primary: INK,
      secondary: GRAPHITE
    },
    divider: STONE,
    error: {
      main: HOTEL_CALIFORNIA
    },
    success: {
      main: GREEN_DAY
    },
    warning: {
      main: YELLOW_SUBMARINE
    },
    background: {
      default: PEBBLE
    }
  },
  shadows,
  typography: typographyOptions,
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: typographyVariant.body1
      }
    },
    MuiCheckbox: {
      root: {
        color: INK
      }
    },
    MuiRadio: {
      root: {
        color: INK
      }
    },
    MuiSnackbarContent: {
      message: {
        color: WHITE
      }
    },
    MuiMenuItem: {
      root: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '1rem'
      }
    },
    MuiSvgIcon: {
      root: {
        fontSize: '1.5rem'
      }
    },
    MuiTableRow: {
      root: {
        height: '3rem'
      }
    },
    MuiTableCell: {
      root: {
        borderBottomColor: STONE
      }
    },
    MuiButton: {
      root: {
        lineHeight: 'unset'
      }
    },
    MuiAccordionActions: {
      root: {
        padding: '24px 24px',
        justifyContent: 'unset'
      }
    },
    MuiAccordionDetails: {
      root: {
        padding: '24px 24px'
      }
    },
    MuiSlider: {
      root: {
        '@media (pointer: coarse)': {
          padding: '20px 0px 5px 0px'
        }
      },
      thumb: {
        width: 24,
        height: 24,
        marginTop: -10,
        border: '2px solid currentColor'
      },
      track: {
        height: 4,
        borderRadius: 4
      },
      rail: {
        height: 4,
        borderRadius: 4,
        color: ROCK
      }
    }
  },
  props: {
    MuiButton: {
      disableFocusRipple: true,
      disableRipple: true
    },
    MuiUseMediaQuery: {
      noSsr: true
    }
  }
};
const theme = createTheme(defaultTheme);
export const cjkTheme = createTheme(deepmerge(defaultTheme, {
  typography: cjkTypographyVariant
}));
export default theme;